import {useEffect, useState} from "react";
import {Box, ImageList, ImageListItem} from "@mui/material";
import { API_URL } from '../../config';
const Corporate = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [corporates, setCorporates] = useState([]);
    const [firstCorpos, setFirstCorpos] = useState([]);
    useEffect(() => {
        fetch(`${API_URL}/photos/category/corporate`)
            .then((res) => res.json())
            .then((data) => setCorporates(data.photos || []));
    }, []);
    useEffect(() => {
        fetch(`${API_URL}/photos/featured?category=corporate`)
            .then((res) => res.json())
            .then((data) => setFirstCorpos(data.photos || []));
    }, []);

    console.log(corporates.photos)
    if(corporates.length < 1) return <div className="loader-ville"><p>Chargement ...</p></div>

    const toggleDiv = () => {
        setIsVisible(!isVisible);
    };



    return(
        <div id="corporate" className="portraits pb-32">
            <h2 className="portraits-title font-bold min-[320px]:text-f-24 xl:text-f-64">Corporate<span>,</span></h2>


            <div className="portraits-container min-[320px]:mt-4 xl:mt-9">
                <div className="flex mb-8 min-[320px]:gap-5 xl:gap-0 min-[320px]:flex-col-reverse xl:flex-row">
                    {firstCorpos.map((photo) => (
                        <div className="flex-1 portraits-container-img min-[320px]:mr-0 xl:mr-8">
                            <img alt={photo.title} src={`${photo.image}`}/>

                        </div>
                    ))}

                    <div className="flex-1 portraits-container-img red-background min-[320px]:w-full xl:w-1/3 flex flex-col justify-between p-6">
                        <p className="text-center">Créez du contenu de qualité pour votre entreprise</p>
                        <button onClick={toggleDiv} className="self-end text-f-22 red-background-link">{isVisible ? <span className="see-less">Voir moins</span>  : <span className="see-more">Voir plus</span>}</button>
                    </div>
                </div>


                <div className={`fade-animation ${isVisible ? "fade-in" : "fade-out"}`}>
                    <div className={`${isVisible ? "fade-in" : "fade-out"}`}   style={{ display: isVisible ? "block" : "none" }}>
                        <Box>
                            <ImageList variant="masonry" cols={3} gap={30} sx={{cols:1}}>
                                {corporates.map((photo) => (
                                    <ImageListItem key={photo.id}>
                                        <img alt={photo.title} src={`${photo.image}`}/>
                                    </ImageListItem>
                                ))};
                            </ImageList>
                        </Box>
                    </div>
                </div>



            </div>
        </div>
    )
}
export default Corporate;